export default __webpack_public_path__ + "static/media/psychiatry.74704273.svg";